export default __webpack_public_path__ + "static/media/3a54497862c283aa.c7ceff077adb3cce9c7875b409e07cb1.svg";